import React, { Component } from 'react';
import { connect } from 'react-redux';
import { breadcrumbs } from '../../../../actions/appActions';
import { push } from 'react-router-redux';
import Grid from '../../../../components/Grid'
import { ColumnType } from '../../../../components/Grid/constants';
import dataProvider, { Order } from '../../../../components/Grid/dataProvider';
import ShowOverviewHistoryButton from '../../components/audit/ShowOverviewHistoryButton';

class InternalUsers extends Component {
  componentWillMount() {
    this.props.breadcrumbs([{ label: 'Administrátoři' }]);
  }

  onEdit = ({ id }) => {
    this.props.push(`${this.props.auth.startUrl}/administratori/${id}`);
  }

  render() {
    const props = {
      columns: [
        {
          field: 'firstName',
          label: 'Jméno',
          type: ColumnType.TEXT,
          width: '20%'
        },
        {
          field: 'lastName',
          label: 'Příjmení',
          type: ColumnType.TEXT,
          width: '15%'
        },
        {
          field: 'userDn',
          label: 'LDAP přihlašovací jméno',
          type: ColumnType.TEXT,
          width: '40%'
        },
        {
          field: 'active',
          label: 'Aktivní',
          type: ColumnType.YESNO,
          sortable: false,
          filterable: false,
          width: '10%'
        },
        {
          field: 'created',
          label: 'Vytvořen',
          type: ColumnType.DATE,
          width: '15%'
        },
      ],
      filtering: true,
      adding: false,
      editing: false,
      addButtonStyle: { color: 'white' },
      deleting: false
    };

    const ConnectedGrid = dataProvider("administratorsGrid", { url: "/spravce/api/administratori", sort: 'created', order: Order.DESC }, Grid);
    return (
      <div>
        <ShowOverviewHistoryButton auth={this.props.auth} segment="administratori" />
        <ConnectedGrid onRowClick={this.onEdit} rowStyle={{ cursor: 'pointer' }} {...props} />
      </div>
    );
  }
}

export default connect(null, { breadcrumbs, push })(InternalUsers);
